
import RegistrationFormComponent from './components/RegistrationFormComponent/RegistrationFormComponent.vue'
import ChooseUserTypeComponent from './components/ChooseUserTypeComponent/ChooseUserTypeComponent.vue'
import ChooseFormTypeComponent from './components/ChooseFormTypeComponent/ChooseFormTypeComponent.vue'
import ChangePasswordComponent from './components/ChangePasswordComponent/ChangePasswordComponent.vue'



const routes = [
    {
        path: '/',
        name: 'ChooseUserTypeComponent',
        component: ChooseUserTypeComponent,
    },
    {
        path: '/choose-form-type',
        name: 'ChooseFormTypeComponent',
        component: ChooseFormTypeComponent,
        props: true
    },
    {
        path: '/registration-form',
        name: 'RegistrationFormComponent',
        component: RegistrationFormComponent,
        props: true
    },
    {
        path: '/change-password',
        name: 'ChangePasswordComponent',
        component: ChangePasswordComponent,
        props: true
    },
]

export default routes